import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AnuncioInteresse } from '../../models/anuncio-interesse.model';
import { Anuncio } from '../../models/anuncio.model';
import { UtilService } from '../../../shared/services/util.service';
import { MessageService } from 'primeng/components/common/messageservice';
import { AnuncioInteresseService } from '../../services/anuncio-interesse.service';
import { CadastroAnuncioService } from 'app/anuncio/services/cadastro-anuncio.service';
import { Router } from '@angular/router';
import { OrigemEnum } from 'app/shared/enum/origem.enum';
import { TagInterface } from 'app/anuncio/models/comuns';

@Component({
  selector: 'reuse-liberar-anuncio',
  templateUrl: './liberar-anuncio.component.html',
  styleUrls: ['./liberar-anuncio.component.scss']
})
export class LiberarAnuncioComponent implements OnInit {




  //evento para avisar que finalizou a análise
  @Output()
  analiseEfetuada = new EventEmitter<AnuncioInteresse>();

  //indica se deve exibir o modal de analisar interesse
  exibirModalLiberarAnuncio: boolean =  false;

  //formulário 'Tenho Interesse'
  formulario?: FormGroup ;

  //anuncio interesse a ser analisado
  anuncio: Anuncio = {} as Anuncio;

  //tipo de republicação do anúncio
  anuncioTipoTic?: number = 0;

  finalizarAnuncio = false;

  constructor(
    private messageService: MessageService,
    private cadastroAnuncioService: CadastroAnuncioService,
    private router: Router,
  ) { }

  ngOnInit() {
  }

  /**
   * Exibir modal.
   */
  exibirModalLiberar(anuncio: Anuncio) {
    this.anuncio = anuncio;
    this.exibirModalLiberarAnuncio = true;
  }

  onCancelar() {
    this.ocultarModal();
  }

  /**
   * Ocultar modal.
   */
  ocultarModal() {
    this.exibirModalLiberarAnuncio = false;
  }


  public onTipoTicChange(value: number) {
    this.finalizarAnuncio = false;
    this.anuncioTipoTic = value;
  }

    public podeAlterarSeEBensTic(): boolean {
        return !this.anuncio.mensagemBloqueio;
  }


  public onConfirmar():void {

    if(this.podeAlterarSeEBensTic() && (this.anuncioTipoTic || this.finalizarAnuncio)) {
      if(this.finalizarAnuncio) {
        this.anuncio.anuncioSituacao.id = 10; //finaliza o anúncio
        this.cadastroAnuncioService.atualizarAnuncioGoverno(this.anuncio).subscribe(
        (resultado: any) => {
            this.messageService.add({severity:'success', summary:'Sucesso', detail:resultado.mensagem});
            this.reloadPage();
          }, () => { });
      } else {
        const tagRepublicMotvo: TagInterface ={
          id: this.anuncioTipoTic || 0,
          nome: this.anuncioTipoTic == 1 ? 'Cumpriu Lei 14.479' : 'Liberado doador Lei 14.479'
        }
        this.anuncio.republicacaoMotivo = tagRepublicMotvo;
        this.cadastroAnuncioService.publicarAnuncioGoverno(this.anuncio).subscribe(
        (resultado: any) => {
          this.messageService.add({severity:'success', summary:'Sucesso', detail:resultado.mensagem});
          this.router.navigate([OrigemEnum.MEUS_ANUNCIOS_GOVERNO]);
        this.reloadPage();
        }, () => { });
      }

    }
      this.ocultarModal();
  }

  public reloadPage(): void {
    setTimeout(() => {
      window.location.reload();
    }, 600);
  }



}
